var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJapan = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30150)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 7.5C14.5 11.366 11.366 14.5 7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5Z",
  fill: "#F0F0F0",
  stroke: "#D7E4F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.50012 10.76C9.30104 10.76 10.761 9.30006 10.761 7.49914C10.761 5.69822 9.30104 4.23828 7.50012 4.23828C5.69919 4.23828 4.23926 5.69822 4.23926 7.49914C4.23926 9.30006 5.69919 10.76 7.50012 10.76Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30150"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJapan);
export { ForwardRef as ReactComponent };